export default __webpack_public_path__ + "static/festl-brass-deschowieda-preview-da49f651752120f246ab3873d136eaf8.jpg";